import React from 'react'
import { Outlet } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { withRouter } from 'src/lib/router/with_router'
import { ReactNotifications } from 'react-notifications-component'
import Footer from 'src/components/system_wide/footer'
import ThemeContext from 'src/components/system_wide/theme_context'
import store from 'src/store'
import { changeConfig } from 'src/store/theme'
import Layout from './layout'

class RiApp extends React.Component {
  state = { ready: false, theme: {} }

  componentDidMount() {
    const theme = store.getState().theme
    this.setState({ ready: true, theme })
  }

  updateThemeConfig = value => {
    store.dispatch(changeConfig(value))
    this.setState(prevState => ({
      ...prevState,
      theme: store.getState().theme,
    }))
  }

  render() {
    const { theme, ready } = this.state

    const isLoginPage = window.location.pathname === '/login'

    if (!ready) {
      return <div className="loading">Caricamento...</div>
    }

    return (
      <HelmetProvider>
        <ThemeContext.Provider value={{ state: theme, dispatch: this.updateThemeConfig }}>
          <ReactNotifications />
          <main className="layout pb-2">
            {isLoginPage ? (
              <Outlet />
            ) : (
              <Layout>
                <Outlet />
              </Layout>
            )}
          </main>
          <Footer containerSize="fluid" />
        </ThemeContext.Provider>
      </HelmetProvider>
    )
  }
}

export default withRouter(RiApp)
